"use client";

import dynamic from "next/dynamic";
import FooterLinks from "./FooterLinks";
import FooterMobileApps from "./FooterMobileApps";
import FooterSocial from "./FooterSocial";
import FooterPayment from "./FooterPayment";
import FooterBottom from "./FooterBottom";
import useFooter from "@/app/lib/features/footer/footer.hook";

// zod + react-hook-form'u initial bundle'dan çıkarmak için lazy-load
// ssr:false — form client-only, SEO için gerekli değil
// Placeholder yüksekliği FooterNewsletter'ın gerçek yüksekliğine eşit olmalı,
// yoksa form yüklenince altındaki her şey zıplar (CLS). Canlıda ÜÇ seçenek var
// (e-posta + telefon + WhatsApp); placeholder ikide kalmıştı.
const FooterNewsletter = dynamic(
  () => import("./FooterNewsletter"),
  {
    ssr: false,
    loading: () => (
      <div className="space-y-1 lg:space-y-2">
        {/* Başlık placeholder */}
        <div className="h-5 sm:h-6 lg:h-7 w-48 rounded bg-gray-200" />
        {/* input+button satırı placeholder'ları */}
        <div className="space-y-3">
          <div className="h-9 md:h-12 rounded bg-gray-200" />
          <div className="h-9 md:h-12 rounded bg-gray-200" />
          <div className="h-9 md:h-12 rounded bg-gray-200" />
        </div>
      </div>
    ),
  },
);

const Footer = () => {
  const { footer } = useFooter();

  if (!footer) return null;

  const menu = Array.isArray(footer.menu) ? footer.menu : [];
  const bottomLinks = Array.isArray(footer.bottom_links)
    ? footer.bottom_links
    : [];
  const hasApps =
    footer.apps &&
    !Array.isArray(footer.apps) &&
    Array.isArray(footer.apps.items);
  const hasSocial =
    footer.social_media &&
    !Array.isArray(footer.social_media) &&
    Array.isArray(footer.social_media.items);
  const hasNewsletter =
    footer.newsletter &&
    !Array.isArray(footer.newsletter) &&
    Array.isArray(footer.newsletter.options);

  return (
    <footer>
      <div className="bg-[#f5f5f5] mt-8 py-2 sm:py-4 lg:py-8">
        <div className="container-minify">
          {/* 5 sütun yan yana: 3 menü + (uygulama & sosyal) + bülten.
              Bülten eskiden 4. sütunun İÇİNDE, uygulama/sosyalın altında
              duruyordu; artık kendi sütunu.

              xl'de 12'lik grid kullanılıyor çünkü beş sütunun eşit olması
              istenmiyor: bülten satırları (ülke kodu + input + buton) yan yana
              sığsın diye 4 birim, menüler 2'şer, uygulama/sosyal 2 birim →
              2+2+2+2+4 = 12.

              lg (1024-1279) bilerek 5'li DEĞİL: orada bülten sütunu ~285px'e
              düşüyor ve telefon alanı ülke kodu + buton ile birlikte sığmıyor.
              O aralıkta üç menü bir satır, uygulama/sosyal + bülten alt satır. */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-12 gap-2 sm:gap-4 lg:gap-8">
            {menu.map((section) => (
              <div key={section.title} className="lg:col-span-1 xl:col-span-2">
                <FooterLinks
                  title={section.title}
                  links={section.items.map((item) => ({
                    label: item.title,
                    href: item.url,
                  }))}
                />
              </div>
            ))}

            {(hasApps || hasSocial) && (
              <div className="flex flex-col space-y-4 lg:space-y-8 sm:col-span-2 lg:col-span-1 xl:col-span-2">
                {hasApps && <FooterMobileApps apps={footer.apps} />}
                {hasSocial && <FooterSocial socialMedia={footer.social_media} />}
              </div>
            )}

            {hasNewsletter && (
              <div className="sm:col-span-2 lg:col-span-2 xl:col-span-4">
                <FooterNewsletter newsletter={footer.newsletter} />
              </div>
            )}
          </div>
          <FooterPayment logos={footer.payment_logos} />
        </div>
      </div>
      <FooterBottom copyrightText={footer.copyright_text} links={bottomLinks} />
    </footer>
  );
};

export default Footer;
